module.exports = __webpack_public_path__ + "static/media/ritualbanners_sm2.958838b8.png";